"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var childrenToArray = function childrenToArray(children) {
  var result = [];

  _react.default.Children.forEach(children, function (child) {
    result.push(child);
  });

  return result;
};

var listOptions = {
  excessKey: true,
  exclusive: true,
  lastWordConnector: true,
  limit: true,
  locale: true,
  twoWordsConnector: true,
  wordsConnector: true
};

var _default = (0, _createReactClass.default)({
  displayName: "FormattedList",
  propTypes: {
    className: _propTypes.default.string,
    excessKey: _propTypes.default.string,
    exclusive: _propTypes.default.bool,
    lastWordConnector: _propTypes.default.string,
    limit: _propTypes.default.number,
    locale: _propTypes.default.string,
    twoWordsConnector: _propTypes.default.string,
    wordsConnector: _propTypes.default.string
  },
  getPassThroughProps: function getPassThroughProps() {
    var _this = this;

    var passThrough = {};
    Object.keys(this.props).forEach(function (key) {
      if (!listOptions[key]) {
        passThrough[key] = _this.props[key];
      }
    });
    return passThrough;
  },
  render: function render() {
    return _react.default.createElement("span", this.getPassThroughProps(), _I18n.default.formatListArray(childrenToArray(this.props.children), this.props));
  }
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/components/FormattedList.js
// module id = 274
// module chunks = 209 210 211 212